// This file is a switch based on enablePIIRedactionImprovements FF
// Once we cleanup the FF, we just need to remove the legacy folder
// and export the piiScrubber imports directly
import {
  cleanPagePath as legacyCleanPagePath,
  scrubValues as legacyScrubValues,
  setupScrubber as legacySetupScrubber,
} from './legacy/piiScrubber';
import {
  GoogleAnalytics,
  cleanPagePath as newCleanPagePath,
  scrubValues as newScrubValues,
  setupScrubber as newSetupScrubber,
  PARAM_REPLACE_TEXT,
} from './piiScrubber';

const cleanPagePath = <T extends string | null | undefined>(
  pagePath: T,
  customAllowList?: string[],
  enablePIIRedactionImprovements?: boolean,
): T =>
  enablePIIRedactionImprovements
    ? newCleanPagePath(pagePath, customAllowList)
    : legacyCleanPagePath(pagePath);

const scrubValues = (
  params: {
    [key: string]: unknown;
  },
  allowList?: {
    [key: string]: boolean;
  },
  enablePIIRedactionImprovements?: boolean,
): void =>
  enablePIIRedactionImprovements
    ? newScrubValues(params, allowList)
    : legacyScrubValues(params, allowList);

const setupScrubber = (
  ga: GoogleAnalytics,
  customAllowList?: string[],
  enablePIIRedactionImprovements?: boolean,
): void =>
  enablePIIRedactionImprovements
    ? newSetupScrubber(ga, customAllowList)
    : legacySetupScrubber(ga);

export {cleanPagePath, scrubValues, setupScrubber, PARAM_REPLACE_TEXT};
